// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "statistics-9O4-s";
export { _1 as "__esModule", _2 as "statistics" }
export default { "__esModule": _1, "statistics": _2 }
